<!-- ── Hero ── -->
<section class="hero">
  <div class="hero-inner">
    <div class="hero-left">
      <a class="back-link" routerLink="/projects" *ngIf="cameFromProjects">
        <mat-icon>arrow_back</mat-icon> Back to Projects
      </a>
      <h1>Create New Project</h1>
      <p class="hero-sub">Fill in the details below to add a new project</p>
    </div>
    <div class="hero-right">
      <div class="hero-icon-wrap">
        <mat-icon>add_business</mat-icon>
      </div>
    </div>
  </div>
</section>

<div class="form-shell">

  <!-- Success -->
  <div *ngIf="success" class="status-bar success">
    <mat-icon>check_circle</mat-icon> Project created successfully! Redirecting…
  </div>

  <!-- Error -->
  <div *ngIf="error" class="status-bar error">
    <mat-icon>error</mat-icon> {{ error }}
  </div>

  <!-- Form Card -->
  <div class="card">
    <div class="card-body">
      <form (ngSubmit)="createProject()" #projectForm="ngForm">

        <!-- Section: Core Info -->
        <div class="section">
          <div class="section-header">
            <mat-icon>info_outline</mat-icon>
            <div>
              <h4>Project Information</h4>
              <p>Basic identifiers for this project</p>
            </div>
          </div>
          <div class="form-grid">
            <div class="field span-half">
              <label for="number">Project Number</label>
              <p class="field-hint">A unique identifier for this project</p>
              <div class="input-wrap">
                <mat-icon class="input-icon">tag</mat-icon>
                <input type="number" id="number" [(ngModel)]="project.projectNumber" name="projectNumber" required placeholder="e.g. 1042" />
              </div>
            </div>

            <div class="field span-half">
              <label for="name">Project Name</label>
              <p class="field-hint">The official name of the project</p>
              <div class="input-wrap">
                <mat-icon class="input-icon">business</mat-icon>
                <input type="text" id="name" [(ngModel)]="project.projectName" name="projectName" required placeholder="Enter project name" />
              </div>
            </div>
          </div>
        </div>

        <!-- Section: Managers -->
        <div class="section">
          <div class="section-header">
            <mat-icon>groups</mat-icon>
            <div>
              <h4>Project Managers</h4>
              <p>Assign the responsible managers for this project</p>
            </div>
          </div>
          <div class="manager-grid">
            <div class="manager-card desimone">
              <div class="manager-card-badge">
                <mat-icon>person</mat-icon>
              </div>
              <label for="pm">DeSimone Manager</label>
              <p class="field-hint">DeSimone person responsible for this project</p>
              <div class="input-wrap">
                <input type="text" id="pm" [(ngModel)]="project.pm" name="pm" required placeholder="DeSimone manager's name" />
              </div>
            </div>

            <div class="manager-card outsource">
              <div class="manager-card-badge outsource-badge">
                <mat-icon>person_outline</mat-icon>
              </div>
              <label for="outsourcePm">{{ company ? company + ' Project Manager' : 'Outsource Project Manager' }}</label>
              <p class="field-hint">Outsource person responsible for this project</p>
              <div class="input-wrap">
                <input type="text" id="outsourcePm" [(ngModel)]="project.outsourcePm" name="outsourcePm" placeholder="Outsource manager's name" />
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <a class="btn-cancel" routerLink="/projects">
            Cancel
          </a>
          <button type="submit" class="btn-primary" [disabled]="loading || !projectForm.valid">
            <mat-icon *ngIf="!loading">add</mat-icon>
            <mat-icon *ngIf="loading" class="spinner">hourglass_empty</mat-icon>
            {{ loading ? 'Creating…' : 'Create Project' }}
          </button>
        </div>

      </form>
    </div>
  </div>

</div>
  